import React from 'react';
import { Column, Row, Section, Text } from '@ydistri/ds';
import { useStableParams } from '../../../routes/useStableParams';
import { useGetAsoConfigurationQuery } from '../apiAso';
import RedistributionAndSets from './groups/RedistributionAndSets';
import StoreTierConfiguration from './groups/StoreTierConfiguration/StoreTierConfiguration';
import SpecialPeriod from './groups/SpecialPeriod';
import RouteValueConstraints from './groups/RouteValueConstraints';
import RouteAndPickingPreferences from './groups/RouteAndPickingPreferences';
import { computeRemSize } from '@ydistri/theme';

const AsoSettings: React.FC = () => {
  const { asoScenarioId } = useStableParams();

  const { isLoading, isError } = useGetAsoConfigurationQuery(asoScenarioId ?? 0, {
    skip: !asoScenarioId,
  });

  return (
    <Section header="Settings" collapsible open>
      {isLoading && <Text>Loading settings…</Text>}
      {isError && <Text $type="danger">Failed to load settings.</Text>}
      {!isLoading && !isError && (
        <Row $gap="1rem" $flexWrap="wrap" $justifyContent="space-between" $padding={1}>
          <Column $width="48rem" $gap="1rem">
            <StoreTierConfiguration />
          </Column>
          <Column $width={computeRemSize(450)} $gap="1rem">
            <RedistributionAndSets />
          </Column>
          <Column $width={computeRemSize(450)} $gap="1rem">
            <RouteValueConstraints />
            <SpecialPeriod />
            <RouteAndPickingPreferences />
          </Column>
        </Row>
      )}
    </Section>
  );
};

export default AsoSettings;
